import { useLogin } from "@/context/useLoginProps";
import { Button, Modal } from "@monsterindia/global-ui-components";
import React, { useEffect, useState } from "react";

import { SelectedEmail } from "../../loginForms/type";
import { MultipleEmailExistProps } from "../../types";

const MultipleEmailModal: React.FC<MultipleEmailExistProps> = ({
  show,
  emails = [],
  onClose,
  onContinue,
  sendOtpLoading = false,
}) => {
  const [selected, setSelected] = useState<SelectedEmail>({
    maskedEmail: "",
    uuid: "",
  });

  const {
    isMobile,
    translation: { login },
  } = useLogin();

  useEffect(() => {
    show &&
      setSelected({
        maskedEmail: "",
        uuid: "",
      });
  }, [show]);

  return (
    <Modal
      id="multipleEmailExistModal"
      customClass="max-w-[653px] p-0"
      isMobile={isMobile}
      showModal={show}
      closeModal={onClose}
      screenAlignment={isMobile ? "bottom-sheet" : "center"}
      showCloseButton={false}
      header={
        <div className="text-content-primary text-lg font-bold">
          {login.sendOtp}
        </div>
      }
    >
      <div className="p-6">
        <div className="text-grey-3 mb-[18px] text-base">
          {login.multipleEmailExistText}
        </div>
        <div className="flex flex-col gap-[18px]">
          {emails.map((val) => (
            <label
              htmlFor={`email-${val.uuid}`}
              className="flex cursor-pointer items-center gap-2"
              key={val.uuid}
            >
              <input
                type="radio"
                id={`email-${val.uuid}`}
                name="emailSelection"
                value={val.uuid}
                checked={selected.uuid === val.uuid}
                onChange={() =>
                  setSelected({ uuid: val.uuid, maskedEmail: val.email })
                }
                className="text-grey-01 cursor-pointer text-sm"
              />
              {` ${val.email}`}
            </label>
          ))}
        </div>
      </div>
      <div className="shadow-top mt-4 flex justify-end gap-2 px-4 py-2">
        <Button
          size="lg"
          type="button"
          id="cancelBtn"
          modifier="tertiary"
          aria-label="cancelBtn"
          label={login.cancel}
          onClick={onClose}
        />
        <Button
          size="lg"
          type="button"
          id="continueBtn"
          modifier="primary"
          aria-label="continueBtn"
          label={login.continue}
          disabled={!selected.uuid}
          isLoading={sendOtpLoading}
          onClick={() => {
            if (selected.uuid) onContinue(selected);
          }}
        />
      </div>
    </Modal>
  );
};

export default MultipleEmailModal;
